export default {
  apiBaseUrl: 'https://pat-api.qhlth.com/api/',
  socketUrl: 'https://pat-api.qhlth.com/',
  webUrl: 'https://pat-app.qhlth.com/',
  accessTokenKey: 'Authorization',
  bearerPrefix: 'bearer',
  expires: 365,
  secure: true,
  nutritionixAppId: '94e4784e',
  nutritionixAppKey: '06b5b7dd2280bfd224041a02ac9b740f',
  withingsClientId:
    'ce6f499a15768464925837c758d215f906cc1f25ea9e44c5f81ee3d680ab8992',
  withingsRedirectUrl: 'https://pat-api.qhlth.com/api/withings/callback',
  fitbitAppClientId: '23TFPX',
  fitbitRedirectWebUri: 'https://localhost:19006/*',
  fitbitRedirectAppUri: 'com.qhlth.pat://home',
  privacyPolicyUrl: 'https://quratehealth.com/privacy',
  loginAgreements: {
    privacyPolicy: 'https://quratehealth.com/privacy'
  },
  debug: true,
  iosAppLink: 'https://apps.apple.com/us/app/qhlth/id6467240849',
  androidAppLink:
    'https://play.google.com/store/apps/details?id=com.qhlth.production',
  videoCallProvider: 'zoom',
  zoomAppGroupId: 'com.qhlth.pat'
};
